declare const STAGE: any;
declare const I18N: any;

export interface RulerSettings {
  scale: number;
  fixed: number;
  unit: string;
}

/**
 * Gibt eine Size-Formatierungsfunktion für einen Ruler zurück
 */
export function simpleSizeFormatter(settings: RulerSettings = STAGE.settings.ruler) {
  return (size: number): string =>
    I18N.formatFloat(size * settings.scale, settings.fixed) + " " + settings.unit;
}
